<template>
  <div class="container-fluid">
    <div class="row" id="app">
      <!-- Inputs Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <TopbarNav />
        <hr/>

        <h5>Input Section</h5>

      </div>

      <!-- Report Section -->
      <div class="col-12 col-lg-6 engineering-paper">
        <h4>Cantilevered Soldier Pile Wall (Simplified Method)</h4>
        <p class="fst-italic">Caltrans Trenching and Shoring Manual</p>


      </div>
    </div>
  </div>
</template>

<script>
  import TopbarNav from "./TopbarNav.vue";

  export default {
    name: "CantileveredSoldierPileWall",
    components: {
      TopbarNav
    },
    data: function () {
      return {

      };
    },
    computed: {

    },
    watch: {

    }
  };
</script>

<style scoped>

</style>
